<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="row">
        <div class="col-lg-6 col-7">
          <h6>{{ $t("payments.shortViewPayment") }}</h6>
          <!-- <p class="text-sm mb-0">
            <i class="fa fa-check text-info" aria-hidden="true"></i>
            <span class="font-weight-bold ms-1">30 done</span> this month
          </p> -->
        </div>
        <div class="col-lg-6 col-5 my-auto text-end">
          <div class="dropdown float-lg-end pe-4">
            <!-- <a
              class="cursor-pointer"
              id="dropdownTable"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="fa fa-ellipsis-v text-secondary" aria-hidden="true"></i>
            </a>
            <ul
              class="dropdown-menu px-2 py-3 ms-sm-n4 ms-n5"
              aria-labelledby="dropdownTable"
            >
              <li>
                <a class="dropdown-item border-radius-md" href="javascript:;"
                  >Action</a
                >
              </li>
              <li>
                <a class="dropdown-item border-radius-md" href="javascript:;"
                  >Another action</a
                >
              </li>
              <li>
                <a class="dropdown-item border-radius-md" href="javascript:;"
                  >Something else here</a
                >
              </li>
            </ul> -->
            <div
              class="pe-md-3 d-flex align-items-center"
              :class="this.$store.state.isRTL ? 'me-md-auto' : 'ms-md-auto'"
            >
              <div>
                <form class="input-group" action="">
                  <input
                    type="text"
                    class="form-control back"
                    v-model="searchQuery"
                    :placeholder="
                      this.$store.state.isRTL
                        ? 'أكتب هنا...'
                        : $t('kids.search')
                    "
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body px-0 pb-2">
      <div class="table-responsive table-container">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                {{ $t("kids.kids") }}
              </th>

              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                {{ $t("Debits") }}
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                {{ $t("payments.unpaidInstallments") }}
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                {{ $t("teachers.pastMonths") }}
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                {{ $t("payments.partiallyPayment") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in filteredKids" :key="item">
              <td>
                <div class="d-flex px-2 py-1">
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ item[0] }}</h6>
                  </div>
                </div>
              </td>

              <td class="align-middle text-center text-sm">
                <span class="text-xs font-weight-bold"
                  >{{ this.moneyFormat(item[1]) }}
                  {{ $t("global.currency") }}</span
                >
              </td>
              <td class="align-middle text-center text-sm">
                <span class="text-xs font-weight-bold">{{ item[4] }}</span>
              </td>
              <td class="align-middle text-center text-sm">
                <span class="text-xs font-weight-bold">{{
                  item[3] + item[4]
                }}</span>
              </td>
              <td class="align-middle">
                <div class="d-flex align-items-center justify-content-center">
                  <span class="text-xs font-weight-bold mx-2">
                    {{ this.percentageFormat(item[3], item[4]) }}</span
                  >
                  <div :class="item[3] + item[4] === 0 ? 'ps-4' : ''">
                    <soft-progress
                      :color="setColor(item)"
                      class="mx-auto"
                      variant="gradient"
                      :percentage="
                        Number((100 * item[3]) / (item[3] + item[4]))
                      "
                    />
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import setTooltip from "@/assets/js/tooltip.js";
//import SoftAvatar from "@/components/SoftAvatar.vue";
import SoftProgress from "@/components/SoftProgress.vue";

export default {
  name: "projects-card",
  props: {
    kids: {
      type: Array,
      require: true,
    },
  },
  data() {
    return {
      searchQuery: "",
    };
  },
  components: {
    //SoftAvatar,
    SoftProgress,
  },
  computed: {
    filteredKids() {
      const search = this.searchQuery.trim().toLowerCase();

      if (!search) {
        return this.kids;
      }

      return this.kids.filter((kid) => {
        return kid[0].toLowerCase().includes(search);
      });
    },
  },
  methods: {
    moneyFormat(value) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
    percentageFormat(item1, item2) {
      let finalPercentage = (100 * item1) / (item1 + item2);
      if (item1 + item2 > 0) {
        return this.moneyFormat(finalPercentage) + "%";
      }
      return "-----";
    },
    setColor(item) {
      return 100 - (100 * item[1]) / item[3] >= 100 ? "success" : "warning";
    },
  },
  mounted() {
    setTooltip();
  },
};
</script>
<style scoped>
.table-container {
  max-height: 400px;
  overflow-y: auto;
}
</style>
